import { ELkType } from '../../repositories/lk-type/entities/get_lk_type_v2/GetLkTypeResponseV2';
import { ELkTypeActionTypes } from '../../actions/lkType';
import { TReduxActions } from '../../types/redux';

const defaultState: ELkType | null = null;

export function lkTypeReducer(state: ELkType | null = defaultState, action: TReduxActions): ELkType | null {
  if (action.type === ELkTypeActionTypes.SetLkType) {
    return action.payload;
  }

  return state;
}
